import {
  CheckUserEventOnDayPromptCompletedDocument,
  type CheckUserEventOnDayPromptCompletedQuery,
  type CheckUserEventOnDayPromptCompletedQueryVariables,
} from '@/entities/on-day-prompt';
import { OnDayPromptPage } from '@/pages/on-day-prompt';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { showError } from '@drisk-ai/ui';
import { type ApolloError } from '@apollo/client';
import {
  checkUserPrivileges,
  SystemPrivilege,
} from '@/entities/authentication';
import { client } from '../../../configs/apollo-client';

export const Route = createFileRoute('/_private/on-day-prompt/$eventUuid')({
  component: OnDayPromptPage,
  async beforeLoad(ctx) {
    const eventUuid = ctx.params.eventUuid;

    const hasPrivilegeToUpsertOnDayPrompt = checkUserPrivileges([
      SystemPrivilege.ManageOnDayPrompt,
    ]);

    if (!hasPrivilegeToUpsertOnDayPrompt) {
      return;
    }

    try {
      const { data, errors } = await client.query<
        CheckUserEventOnDayPromptCompletedQuery,
        CheckUserEventOnDayPromptCompletedQueryVariables
      >({
        query: CheckUserEventOnDayPromptCompletedDocument,
        variables: {
          input: {
            eventUuid,
          },
        },
      });

      if (errors?.[0]) {
        if (errors?.[0].message.includes('Event is ended')) {
          return redirect({ to: `/events/${eventUuid}` });
        }
        // Don't allow user to access on day prompt page when having error
        showError((errors?.[0] as ApolloError).message);
        return redirect({ to: '/events', replace: true });
      }

      if (data && data.checkUserEventOnDayPromptCompleted.isCompleted) {
        return redirect({ to: `/events/${eventUuid}` });
      }
    } catch (error) {
      showError((error as ApolloError).message);
      redirect({ to: '/events', replace: true });
    }
  },
});
